/* eslint-disable import/prefer-default-export */
export const Events = {
  ADDITIONAL_EMAILS_ADDING_FAILED: 'additionalEmailsAddingFailed',
  ADDITIONAL_EMAILS_ADDING_STARTED: 'additionalEmailsAddingStarted',
  ADDITIONAL_EMAILS_ADDING_SUCCEED: 'additionalEmailsAddingSucceed',
  ADDITIONAL_EMAILS_DELETING_FAILED: 'additionalEmailsDeletingFailed',
  ADDITIONAL_EMAILS_DELETING_STARTED: 'additionalEmailsDeletingStarted',
  ADDITIONAL_EMAILS_DELETING_SUCCEED: 'additionalEmailsDeletingSucceed',
  FUNDING_SOURCES_LOADING_FAILED: 'fundingSourcesLoadingFailed',
  FUNDING_SOURCES_LOADING_STARTED: 'fundingSourcesLoadingStarted',
  FUNDING_SOURCES_LOADING_SUCCEED: 'fundingSourcesLoadingSucceed',
  DEFAULT_FUNDING_SOURCE_UPDATED: 'defaultFundingSourceUpdated',
  GO_TO_FUNDING_SOURCES_SEGMENT: 'goToFundingSourcesSegment',
  GO_TO_UPCOMING_TRANSACTIONS_SEGMENT: 'goToUpcomingTransactionsSegment',
  HIDE_ALERT_FOR_UPCOMING_TRANSACTIONS: 'hideAlertForUpcomingTransactions',
  HIDE_SUCCESS_ALERT: 'hideSuccessAlert',
  IMPACT_PREFERENCES_LOADING_FAILED: 'impactPreferencesLoadingFailed',
  IMPACT_PREFERENCES_LOADING_STARTED: 'impactPreferencesLoadingStarted',
  IMPACT_PREFERENCES_LOADING_SUCCEED: 'impactPreferencesLoadingSucceed',
  NOTES_LOADING_FAILED: 'notesLoadingFailed',
  NOTES_LOADING_STARTED: 'notesLoadingStarted',
  NOTES_LOADING_SUCCEED: 'notesLoadingSucceed',
  OPEN_MODAL_TO_ADD_NEW_FUNDING_SOURCE: 'openModalToAddNewFundingSource',
  RATE_AND_TERM_IS_INVALID: 'rateAndTermIsInvalid',
  RATE_AND_TERM_IS_VALID: 'rateAndTermIsValid',
  RATE_CHANGED: 'rateChanged',
  REDIRECT_TO_NOTE_DETAILS_VIEW: 'redirectToNoteDetailsView',
  REDIRECT_TO_PURCHASE_INVESTMENT_NOTE_VIEW: 'redirectToPurchaseInvestmentNoteView',
  REPRESENTATIVE_ADDED: 'representativeAdded',
  REPRESENTATIVES_UPDATED: 'representativesUpdated',
  RESTART: 'restart',
  SHOW_ALERT_FOR_UPCOMING_TRANSACTIONS_WITH_ACTION: 'showAlertForUpcomingTransactionsWithAction',
  SHOW_ALERT_FOR_UPCOMING_TRANSACTIONS_WITH_NO_ACTION: 'showAlertForUpcomingTransactionsWithNoAction',
  TERM_CHANGED: 'termChanged',
  REPRESENTATIVE_LOADING_FAILED: 'representativeLoadingFailed',
  REPRESENTATIVE_LOADING_STARTED: 'representativeLoadingStarted',
  REPRESENTATIVE_LOADING_SUCCEED: 'representativeLoadingSucceed',
  UPCOMING_TRANSACTIONS_LOADING_FAILED: 'upcomingTransactionsLoadingFailed',
  UPCOMING_TRANSACTIONS_LOADING_STARTED: 'upcomingTransactionsLoadingStarted',
  UPCOMING_TRANSACTIONS_LOADING_SUCCEED: 'upcomingTransactionsLoadingSucceed',
  UPDATE_IMPACT_PREFERENCES_FAILED: 'updateImpactPreferencesFailed',
  UPDATE_IMPACT_PREFERENCES_STARTED: 'updateImpactPreferencesStarted',
  UPDATE_IMPACT_PREFERENCES_SUCCEED: 'updateImpactPreferencesSucceed',
  BENEFICIARY_LOADING_FAILED: 'beneficiaryLoadingFailed',
  BENEFICIARY_LOADING_STARTED: 'beneficiaryLoadingStarted',
  BENEFICIARY_LOADING_SUCCEED: 'beneficiaryLoadingSucceed',
  BENEFICIARIES_UPDATED: 'beneficiariesUpdated',
  USER_MERGE_REQUESTED: 'userMergeRequested',
};



// WEBPACK FOOTER //
// ./src/data/static/events.js